export const containerWidth = 1140
export const containerPadding = 6
export const containerMobilePadding = 14
export const headerHeight = 66
export const headerMargin = 30
export const sectionMargin = 90
export const sectionMobileMargin = 40
export const blockTextHeight = 330
export const sidebarWidth = 250
export const contentWidth = 860
export const headerParagraphFontSize = 22

export const tosLinks: { title: string; link: string }[] = [
    {
        title: 'Terms of Service',
        link: 'https://support.giphy.com/hc/en-us/articles/360020027752-GIPHY-User-Terms-of-Service',
    },
    {
        title: 'Community Guidelines',
        link: 'https://support.giphy.com/hc/en-us/articles/360020286811-GIPHY-Community-Guidelines',
    },
    {
        title: 'Privacy Policy',
        link: 'https://support.giphy.com/hc/en-us/articles/360020028332-GIPHY-Privacy-Policy',
    },
    {
        title: 'Copyright',
        link: 'https://support.giphy.com/hc/en-us/articles/360020287091-GIPHY-DMCA-Copyright-Policy',
    },
]
